/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_A1Inputs */

const en_to_yaml_faq_a1 = /** @type {(inputs: To_Yaml_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The converter produces valid YAML that can be used directly in configuration files, Kubernetes manifests, and other YAML-compatible tools.`)
};

const ko_to_yaml_faq_a1 = /** @type {(inputs: To_Yaml_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 변환기는 설정 파일, Kubernetes 매니페스트 및 기타 YAML 호환 도구에서 바로 사용할 수 있는 유효한 YAML을 생성합니다.`)
};

const ja_to_yaml_faq_a1 = /** @type {(inputs: To_Yaml_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。コンバーターは設定ファイル、Kubernetesマニフェスト、その他のYAML対応ツールで直接使用できる有効なYAMLを生成します。`)
};

/**
* | output |
* | --- |
* | "Yes. The converter produces valid YAML that can be used directly in configuration files, Kubernetes manifests, and other YAML-compatible tools." |
*
* @param {To_Yaml_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_a1 = /** @type {((inputs?: To_Yaml_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_a1(inputs)
	if (locale === "ko") return ko_to_yaml_faq_a1(inputs)
	return ja_to_yaml_faq_a1(inputs)
});